import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext.jsx';
import { createScholar } from '../lib/scholars.js';
import ScholarForm from '../components/scholars/ScholarForm.jsx';

export default function ScholarsNew() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, profile, isAdmin, isActive } = useAuth();
  const [search] = useSearchParams();
  const selfClaim = search.get('self') === '1';
  const [busy, setBusy] = useState(false);
  const [submitted, setSubmitted] = useState(null);

  if (!isActive) {
    return (
      <div className="mx-auto max-w-2xl px-8 pb-20 pt-32">
        <div className="cta-box">
          <h1 className="cta-title">{t('bibliography.form.notActiveTitle')}</h1>
          <p className="cta-body">{t('bibliography.form.notActiveBody')}</p>
        </div>
      </div>
    );
  }

  if (submitted) {
    const adminPublished = isAdmin || selfClaim === false ? false : false; // we just look at status below
    const wasPublished = submitted.status === 'published';
    return (
      <div className="mx-auto max-w-2xl px-8 pb-20 pt-32">
        <div className="cta-box">
          <div className="section-label">
            {wasPublished ? t('scholars.form.publishedLabel') : t('scholars.form.submittedLabel')}
          </div>
          <h1 className="cta-title">{submitted.name}</h1>
          <p className="cta-body">
            {wasPublished
              ? t('scholars.form.publishedBody')
              : t('scholars.form.submittedBody')}
          </p>
          <button
            type="button"
            className="btn-primary"
            onClick={() => navigate('/scholars')}
          >
            {t('scholars.form.backToList')}
          </button>
        </div>
      </div>
    );
  }

  async function handleSubmit(form) {
    setBusy(true);
    try {
      const created = await createScholar(form, {
        authorId: user.id,
        selfClaim,
        asAdmin: isAdmin,
      });
      setSubmitted(created);
    } finally {
      setBusy(false);
    }
  }

  // Pre-fill the user's display_name when claiming their own profile.
  const initialValue = selfClaim && profile
    ? { name: profile.display_name || '' }
    : null;

  return (
    <div className="mx-auto max-w-3xl px-6 pb-20 pt-28">
      <header className="mb-8">
        <div className="section-label">
          {selfClaim ? t('scholars.form.selfLabel') : t('scholars.form.newLabel')}
        </div>
        <h1 className="font-serif text-3xl font-semibold text-cream">
          {selfClaim ? t('scholars.form.selfHeading') : t('scholars.form.newHeading')}
        </h1>
        <p className="mt-2 text-sm text-ink-secondary">
          {isAdmin
            ? t('scholars.form.newSubheadingAdmin')
            : selfClaim
            ? t('scholars.form.selfSubheading')
            : t('scholars.form.newSubheadingCollaborator')}
        </p>
      </header>

      <ScholarForm
        initialValue={initialValue}
        submitLabel={
          isAdmin
            ? t('scholars.form.publish')
            : t('scholars.form.submitForReview')
        }
        onSubmit={handleSubmit}
        onCancel={() => navigate('/scholars')}
        busy={busy}
      />
    </div>
  );
}
